<div class="mb-4 flex items-center justify-between gap-4">
	<div class="text-base font-bold text-black">Feedback Management</div>
	@if (!isGroupAdmin) {
		<button
			class="aa-btn shrink-0"
			data-size="small"
			data-variant="primary"
			(click)="createNew()"
			[disabled]="!isOnline"
		>
			<span class="aa-mat-icon">add_box</span> Create New
		</button>
	}
</div>

<div class="mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
	<div class="flex min-w-0 flex-1 flex-wrap items-center gap-3">
		<div class="w-full max-w-xs">
			<div class="relative">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
					<input matInput [(ngModel)]="searchQuery" (input)="onSearch()" placeholder="Search" class="pr-10" />
					<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
				</mat-form-field>
			</div>
		</div>
		<div class="w-[220px] shrink-0">
			@if (isGroupAdmin) {
				<div class="w-[220px]">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
						<mat-select
							[(value)]="selectedAocIds"
							(selectionChange)="onAocFilterChanged($event.value)"
							placeholder="AOC"
							multiple
							hideSingleSelectionIndicator
						>
							@for (option of aocFilterOptions; track option.value) {
								<mat-option [value]="option.value">{{ option.label }}</mat-option>
							}
						</mat-select>
						<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
					</mat-form-field>
				</div>
			} @else {
				<div class="w-[220px]">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
						<mat-select
							[(value)]="selectedFormType"
							(selectionChange)="onFormTypeFilter($event.value)"
							placeholder="Form type"
						>
							<mat-option value="">All</mat-option>
							@for (option of formTypeFilterOptions; track option.value) {
								<mat-option [value]="option.value">{{ option.label }}</mat-option>
							}
						</mat-select>
						<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
					</mat-form-field>
				</div>
			}
		</div>
	</div>
	<app-cbta-daterange-filter
		class="ml-auto"
		[startDate]="startDate"
		[endDate]="endDate"
		[enabled]="dateFilterEnabled"
		(dateRangeSelected)="handleDateRangeChange($event)"
	></app-cbta-daterange-filter>
</div>

<div class="cbta-tbl forms-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="templates"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<ng-template #titleTpl let-row>
			<span [title]="row.name">{{ row.name }}</span>
		</ng-template>

		<ng-template #formNameTpl let-row>
			<span [class.text-violet]="row.isStandalone" [title]="getFormNames(row)">{{ getFormNames(row) }}</span>
		</ng-template>

		<ng-template #formTypeTpl let-row>
			<div class="flex min-w-0 flex-col gap-1">
				<span class="font-bold" [class.text-violet]="row.isStandalone">{{ getFormTypeLabel(row) }}</span>
				@if (row.isStandalone) {
					@if (hasScheduleWindow(row)) {
						<span class="break-words text-xs text-grey-60">{{ formatScheduleWindow(row) }}</span>
					}
					@if (isScheduled(row)) {
						<span class="break-words text-xs font-medium text-violet"> Scheduled: {{ scheduledStartLabel(row) }} </span>
					}
				}
			</div>
		</ng-template>

		<ng-template #aocTpl let-row>
			<span class="font-bold">{{ row.aocCode || "-" }}</span>
		</ng-template>

		<ng-template #dateTpl let-row>
			<span class="text-violet">{{ formatDate(row.lastUpdated) }}</span>
		</ng-template>

		<ng-template #actionTpl let-row>
			<div class="flex justify-center">
				<button mat-icon-button [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{ row }">
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</ng-template>

		<mat-menu #actionMenu="matMenu" class="!min-w-36 border border-[#CFE3FF] px-1 !shadow-sm">
			<ng-template matMenuContent let-row="row">
				@if (!isGroupAdmin) {
					<button class="menu-btn" (click)="editTemplate(row.id)" [disabled]="!isOnline">
						<span>Edit</span>
					</button>
				}
				<button class="menu-btn" (click)="viewResponses(row.id)">
					<span>View Response</span>
				</button>
				@if (row.isStandalone && !isGroupAdmin) {
					<button class="menu-btn" (click)="sendOut(row)" [disabled]="!canSendForm(row)">
						<span>Send Form</span>
					</button>
				}
				@if (!isGroupAdmin && canDelete(row)) {
					<button class="menu-btn hover:!bg-red" (click)="deleteTemplate(row)">
						<span>Delete</span>
					</button>
				}
			</ng-template>
		</mat-menu>

		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[180px] text-center">
				<span class="text-grey-40">No feedback templates found.</span>
			</td>
		</ng-template>
	</div>
</div>
